import { assignDefaultLocale } from '@/services/dateTime/datetimeService';
import * as Mutations from '../../mutations';

export default {
  [Mutations.SET_LANGUAGE](store, language) {
    store.language = language;
    assignDefaultLocale(language.key);
  },
  [Mutations.SET_FONT_SIZE](store, fontSize) {
    store.currentFontSize = fontSize;
  },
  [Mutations.SET_APP_THEME](store, appTheme) {
    store.appTheme = appTheme;
  },
  [Mutations.SET_APP_CONFIGURATION](store, configuration) {
    store.appConfiguration = configuration;
    store.errorGettingApplicationData = false;
  },
  [Mutations.SET_ERROR_GETTING_APP_CONFIGURATION](store) {
    store.appConfiguration = null;
    store.errorGettingApplicationData = true;
  },
  [Mutations.SET_PRINTING_MODE](store, state) {
    store.isPrinting = state;
  },
};
